import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link, useParams } from 'react-router';
import { EmptyState, PageHeader } from '@/shared/ui';
import { OrderInquiryDetail } from '@/widgets/order-inquiry-detail';

/** 어드민 문의 상세(/order-inquiries/:inquiryId) — 주소 해석만 하고 내용은 위젯이 그린다. */
export const OrderInquiryDetailPage = (): ReactElement => {
  const { inquiryId } = useParams<{ inquiryId: string }>();
  const parsed = normalizedUuidSchema.safeParse(inquiryId);

  return (
    <>
      <PageHeader
        title="문의 상세"
        actions={
          <Link to="/order-inquiries" className="text-sm underline underline-offset-4">
            목록으로
          </Link>
        }
      />
      {parsed.success ? (
        <OrderInquiryDetail key={parsed.data} inquiryId={parsed.data} />
      ) : (
        <EmptyState isError>올바른 문의 주소가 아닙니다.</EmptyState>
      )}
    </>
  );
};
